import { useContext } from "react";
import { SignalmizelyContext } from "../context.js";
export function useSignalmizely() {
    const context = useContext(SignalmizelyContext);
    if (!context) {
        throw new Error("useSignalmizely must be used within a SignalmizelyProvider");
    }
    return context.helpers;
}
